import { gql } from '@/__generated__/gql'

export const ContentDetailsPersonContentFragment = gql(`
  fragment ContentDetails_Person_ContentFragment on Content{
    id
    title
    language
    contentType
    contentId
    published
    avatar: imageContentRelationships {
      id
      type
      image {
        id
        url
      }
    }
  }
`)

export const ContentDetailsPersonContentReferenceFragment = gql(`
  fragment ContentDetails_Person_ContentReferenceFragment on ContentReference{
    id
    sortKey
    contentReferenceType {
      id
      type
    }
    contentTo {
      ...ContentDetails_Person_ContentFragment
    }
  }
`)
